import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { RouteMap } from "components/common/navigation/routeMap";
import {
  loadBenefitsSurvey,
  saveBenefitsSurvey,
  disableRedirection,
} from "actions/benefitsSurveyActions";
import SurveyForm from "./SurveyForm";
import { Loader } from "cxa-components";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";

class Survey extends React.Component {
  componentDidMount = () => {
    const { loadBenefitsSurvey } = this.props;
    loadBenefitsSurvey();
  };

  redirectPage = (priority1, priority2) => {
    const { isEnrolmentEnabled, push } = this.props;

    if (isEnrolmentEnabled) {
      push(RouteMap[priority1]);
    } else {
      push(RouteMap[priority2]);
    }
  };

  handleSave = data => {
    const {
      surveyData: { id, submitRedirectToPage: { priority1 = "" } } = {},
      saveBenefitsSurvey,
    } = this.props;

    //Check if needed to be redirected after submit
    let redirectAfterSubmit = false;
    if (priority1 !== "") {
      redirectAfterSubmit = true;
    }

    saveBenefitsSurvey(id, data, redirectAfterSubmit);
  };

  handleCancel = () => {
    const { surveyData: { cancelRedirectToPage } = {} } = this.props;
    const { priority1, priority2 } = cancelRedirectToPage;

    //Check if needed to be redirected after cancel
    if (priority1 !== "") {
      this.redirectPage(priority1, priority2);
    }
  };

  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate(nextProps) {
    const {
      redirectAfterSubmit,
      surveyData: { submitRedirectToPage = {} },
    } = nextProps;
    const { priority1 = "", priority2 = "" } = submitRedirectToPage;

    if (redirectAfterSubmit) {
      this.redirectPage(priority1, priority2);
    }
  }

  componentWillUnmount = () => {
    const { disableRedirection } = this.props;
    disableRedirection();
  };

  render() {
    const { fetching, surveyData, error, intl } = this.props;
    if (fetching) {
      return <Loader />;
    }

    const { name, description, questions = [], answersByQuestionID } = surveyData;

    if (questions.length < 1) {
      return <div className="no-data-message">{intl.formatMessage(messages.surveyNotAvailable)}</div>;
    }

    return (
      <div>
        <h2>{intl.formatMessage({ id: name, defaultMessage: name })}</h2>
        <SurveyForm
          onSubmit={this.handleSave}
          cancel={this.handleCancel}
          description={description}
          fields={questions}
          initialValues={answersByQuestionID}
          err={error}
          {...this.props}
        />
      </div>
    );
  }
}

Survey.propTypes = {
  error: PropTypes.object,
  fetching: PropTypes.bool,
  surveyData: PropTypes.object.isRequired,
  loadBenefitsSurvey: PropTypes.func.isRequired,
  saveBenefitsSurvey: PropTypes.func.isRequired,
  isEnrolmentEnabled: PropTypes.bool,
  redirectAfterSubmit: PropTypes.bool,
  disableRedirection: PropTypes.func,
  push: PropTypes.func,
  intl: intlShape.isRequired,
};

const mapStateToProps = ({
  benefitsSurvey: { fetching, surveyData, error, redirectAfterSubmit },
  common: { isEnrolmentEnabled },
}) => ({
  fetching,
  surveyData,
  error,
  redirectAfterSubmit,
  isEnrolmentEnabled: isEnrolmentEnabled || surveyData.hasOpenEnrollment,
});

const mapDispatchToProps = {
  loadBenefitsSurvey,
  saveBenefitsSurvey,
  disableRedirection,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Survey));



// WEBPACK FOOTER //
// ./components/employee/benefits/Survey.js